import React, { useEffect, useState, useMemo } from 'react'
import { Helmet } from 'react-helmet'
// import HomeComponent from '../../Components/Index';
import VocationOneComponent from '../../Components/AppVocationOne'
import VocationJuniorComponent from '../../Components/AppVocationJunior'
import VocationStartComponent from '../../Components/AppVocationStart'
import AuthRutId from '../../Components/Auth/App'
import LogInForm from '../../Components/Auth/App/LogInForm'
import TestingMenu from '../../Components/AppTestingMenu'
import PrevResponsesSelect from '../../Components/Auth/App/PrevResponsesSelect'

import { StageProvider, StageConsumer } from '../../Context/app-stage-context'
import { DataProvider, useDataContext } from '../../Context/campaign-context'

// parse url query string, e.g.
// url test mode ?mode=testingMode
// url school ?school=Santiago+College
const getQuery = param => {
  if (!param) {
    return null
  }
  const query = new URLSearchParams(window.location.search)
  const result = query.get(param)
  return result
}

const SwitchPage = props => {
  const [user, setUser] = useState(null)
  const { campaign, isLoading, userData, setUserData, prevResponses } =
    useDataContext()

  // check for prev responses
  // console.log({ prevResponses })
  const responses = useMemo(() => {
    return prevResponses
  }, [prevResponses])

  useEffect(() => {
    // login and set user??
    // console.log({ userData });
    if (userData === null) {
      setUser(null)
    }
    if (userData) {
      setUser(userData)
    }
    // setUser({
    //   rut: '654654645',
    //   name: 'Testing',
    //   lastname: 'VocationOne',
    //   email: 'testing@testing.com'
    // });
  }, [userData])

  const appMode = getQuery('mode')
  const isTestingMode = appMode === 'testingMode'
  // console.log({ appMode, isTestingMode });
  const testing = isTestingMode // true;

  if (isLoading) {
    return <div>Cargando...</div>
  }
  if (!campaign && !isLoading) {
    console.log('not found, redirect')
    return <div>Campaña no encontrada</div>
  }
  // console.log({ campaign });
  const { SKU } = campaign

  const multiple = true
  const withAuth = !!user
  // console.log({ user });

  return (
    <StageProvider>
      <StageConsumer>
        {({ state, updateContext, nextStage, prevStage }) => {
          if (!user) {
            return (
              <div>
                <Helmet>
                  {SKU === 'VOCATION_ONE' && (
                    <title>
                      {campaign.organization || campaign.title} - Vocation One |
                      EduMetrics
                    </title>
                  )}
                  {SKU === 'VOCATION_JUNIOR' && (
                    <title>
                      {campaign.organization || campaign.title} - Vocation
                      Junior | EduMetrics
                    </title>
                  )}
                  {SKU === 'VOCATION_START' && (
                    <title>
                      {campaign.organization || campaign.title} - Vocation Start
                      | EduMetrics
                    </title>
                  )}
                </Helmet>
                <LogInForm {...state} campaign={campaign} SKU={SKU} />
              </div>
            )
          }
          // if prev responses
          if (responses?.length > 0) {
            return (
              <div>
                <Helmet>
                  {SKU === 'VOCATION_ONE' && (
                    <title>
                      {campaign.organization || campaign.title} - Vocation One |
                      EduMetrics
                    </title>
                  )}
                  {SKU === 'VOCATION_JUNIOR' && (
                    <title>
                      {campaign.organization || campaign.title} - Vocation
                      Junior | EduMetrics
                    </title>
                  )}
                  {SKU === 'VOCATION_START' && (
                    <title>
                      {campaign.organization || campaign.title} - Vocation Start
                      | EduMetrics
                    </title>
                  )}
                </Helmet>
                <PrevResponsesSelect {...state} campaign={campaign} SKU={SKU} />
              </div>
            )
          }

          return (
            <React.Fragment>
              <Helmet>
                {SKU === 'VOCATION_ONE' && (
                  <title>
                    {campaign.organization || campaign.title} - Vocation One |
                    EduMetrics
                  </title>
                )}
                {SKU === 'VOCATION_JUNIOR' && (
                  <title>
                    {campaign.organization || campaign.title} - Vocation Junior
                    | EduMetrics
                  </title>
                )}
                {SKU === 'VOCATION_START' && (
                  <title>
                    {campaign.organization || campaign.title} - Vocation Start |
                    EduMetrics
                  </title>
                )}
              </Helmet>

              {SKU === 'VOCATION_ONE' && (
                <VocationOneComponent
                  {...props}
                  {...state}
                  setUserData={setUserData}
                  state={state}
                  updateContext={updateContext}
                  toNextStage={nextStage}
                  campaign={campaign}
                  withAuth={withAuth}
                  user={user}
                />
              )}

              {SKU === 'VOCATION_JUNIOR' && (
                <VocationJuniorComponent
                  {...props}
                  {...state}
                  setUserData={setUserData}
                  state={state}
                  updateContext={updateContext}
                  toNextStage={nextStage}
                  campaign={campaign}
                  withAuth={withAuth}
                  user={user}
                  // school={school}
                  // rut={rut}
                />
              )}

              {SKU === 'VOCATION_START' && (
                <VocationStartComponent
                  {...props}
                  {...state}
                  setUserData={setUserData}
                  state={state}
                  updateContext={updateContext}
                  toNextStage={nextStage}
                  campaign={campaign}
                  withAuth={withAuth}
                  user={user}
                />
              )}

              {testing && (
                <TestingMenu
                  {...state}
                  campaign={campaign}
                  user={user}
                  toNextStage={nextStage}
                  toPrevStage={prevStage}
                  vocationOne={Boolean(['VOCATION_ONE'].includes(SKU))}
                  vocationJunior={Boolean(['VOCATION_JUNIOR'].includes(SKU))}
                />
              )}
              {multiple && (
                <AuthRutId {...state} campaign={campaign} user={user} />
              )}
            </React.Fragment>
          )
        }}
      </StageConsumer>
    </StageProvider>
  )

  return <div>Ha ocurrido un error, revisa si la url es correcta</div>
}

const DataWrapper = props => {
  // console.log({ props });
  return (
    <DataProvider id={props.match.params.id}>
      <SwitchPage {...props} />
    </DataProvider>
  )
}
export default DataWrapper
